@if (client$ | async; as client) {
    <div class="heading">
        <h1>Streams</h1>
        <p>Edit and manage Streams</p>
        <div class="flex align-end">
            <button mat-flat-button (click)="addStream()">
                <mat-icon>add</mat-icon>
                Add new Stream
            </button>
        </div>
    </div>
    @if (streams$ | async; as streams) {
        <div class="flex row">
            <div class="flex-30 streams-list">
                <mat-tree
                    [dataSource]="streamTree.dataSource"
                    [treeControl]="streamTree.treeControl"
                >
                    <!-- Leaf -->
                    <mat-tree-node
                        *matTreeNodeDef="let node"
                        matTreeNodePadding
                        (click)="selectStream(node.stream)"
                        class="flex row justify-space-between"
                        [class.active]="node.stream.id === activeStream?.id"
                    >
                        <div class="flex align-start pad-left">
                            <mat-icon>{{ isPrivate(node.stream) ? "lock" : "grid_view" }}</mat-icon>
                            &nbsp;&nbsp;{{ node.name }}
                        </div>
                        @if (!node.parent) {
                            <button mat-icon-button (click)="addStream(node.stream)">
                                <mat-icon>add</mat-icon>
                            </button>
                        }
                    </mat-tree-node>
                    <!-- Root -->
                    <mat-tree-node
                        *matTreeNodeDef="let node; when: hasChild"
                        matTreeNodePadding
                        (click)="selectStream(node.stream)"
                        class="flex row justify-space-between"
                        [class.active]="node.stream.id === activeStream?.id"
                    >
                        <button mat-icon-button matTreeNodeToggle class="">
                            <mat-icon>
                                {{
                                    streamTree.treeControl.isExpanded(node)
                                        ? "expand_more"
                                        : "chevron_right"
                                }}
                            </mat-icon>
                        </button>
                        <div class="flex align-start">
                            <mat-icon>{{ node.stream.private ? "lock" : "grid_view" }}</mat-icon>
                            &nbsp;&nbsp;{{ node.name }}
                        </div>
                        @if (!node.parent) {
                            <button mat-icon-button (click)="addStream(node.stream)" class="">
                                <mat-icon>add</mat-icon>
                            </button>
                        }
                    </mat-tree-node>
                </mat-tree>
            </div>
            <div class="flex-70">
                <form [formGroup]="form">
                    <div>
                        @if (activeStream) {
                            <mat-card appearance="outlined">
                                <mat-card-content>
                                    <mat-form-field appearance="fill">
                                        <mat-label>Name</mat-label>
                                        <input matInput formControlName="name" />
                                    </mat-form-field>
                                    @if (!activeStream.parent) {
                                        <mat-checkbox formControlName="inclusive"
                                            >Include Child Content</mat-checkbox
                                        >
                                    }
                                    <br />
                                    <mat-checkbox formControlName="include_slack"
                                        >Include in Slack</mat-checkbox
                                    >
                                    <br />
                                    <mat-checkbox formControlName="read_only"
                                        >Read Only</mat-checkbox
                                    >
                                    <br />
                                    @if (!activeStream.parent && client.is_paid) {
                                        <mat-checkbox formControlName="private"
                                            >Private</mat-checkbox
                                        >
                                    }
                                    @if (activeStream.private) {
                                        <mat-divider></mat-divider>
                                        <h2>Members</h2>
                                        <button
                                            mat-flat-button
                                            color="primary"
                                            (click)="addMembers()"
                                        >
                                            Add Members
                                        </button>
                                        <mat-list>
                                            @for (member of members; track member) {
                                                <mat-list-item>
                                                    <img
                                                        matListItemIcon
                                                        width="24"
                                                        height="24"
                                                        src="{{ member.email_hash | identicon | async }}"
                                                    />
                                                    <div
                                                        matListItemLine
                                                        class="flex row align-items-center"
                                                    >
                                                        {{ member.name }}
                                                        <button
                                                            mat-icon-button
                                                            (click)="removeMember(member)"
                                                        >
                                                            <mat-icon>close</mat-icon>
                                                        </button>
                                                    </div>
                                                </mat-list-item>
                                            }
                                        </mat-list>
                                    }
                                </mat-card-content>
                                <mat-card-actions>
                                    <button
                                        mat-flat-button
                                        color="primary"
                                        (click)="saveStream()"
                                        [disabled]="form.pristine"
                                    >
                                        Save
                                    </button>
                                    @if (streamToDelete === null) {
                                        <button
                                            mat-stroked-button
                                            color="warn"
                                            (click)="initiateDelete()"
                                        >
                                            Remove
                                        </button>
                                    }
                                </mat-card-actions>
                            </mat-card>
                        } @else {
                            <mat-card appearance="outlined">
                                <mat-card-content>
                                    <p>Select a Stream to edit</p>
                                </mat-card-content>
                            </mat-card>
                        }
                        @if (streamToDelete !== null) {
                            <div>
                                @if (streamToDelete.parent !== null) {
                                    <p>
                                        Would you like to Merge the content in this stream with it's
                                        parent or Delete everything?
                                    </p>
                                    <button
                                        mat-stroked-button
                                        color="accent"
                                        (click)="removeStream(true)"
                                    >
                                        Merge
                                    </button>
                                    <button
                                        mat-stroked-button
                                        color="warn"
                                        (click)="removeStream(false)"
                                    >
                                        Delete
                                    </button>
                                } @else {
                                    @if (streamToDelete.children.length === 0) {
                                        <p>This will remove all content within the Stream</p>
                                        <button
                                            mat-stroked-button
                                            color="warn"
                                            (click)="removeStream(false)"
                                        >
                                            Delete
                                        </button>
                                    } @else {
                                        <p>
                                            This will remove all content within the Stream and all
                                            of it's child Streams
                                        </p>
                                        <button
                                            mat-stroked-button
                                            color="warn"
                                            (click)="removeStream(false)"
                                        >
                                            Delete
                                        </button>
                                    }
                                }
                                <button mat-button (click)="streamToDelete = null">Cancel</button>
                            </div>
                        }
                    </div>
                </form>
            </div>
        </div>
    }
}
